<template>
    <div :class="theme.wrapper" @click="handleOpen" @mouseleave="handleBlur" @mouseenter="handleFocus">
        <slot></slot>
        <transition name="fade" :enter-active-class="theme.fadeEnterActive" :enter-class="theme.fadeEnter" :enter-to-class="theme.fadeEnterTo" :leave-active-class="theme.fadeLeaveActive" :leave-class="theme.fadeLeave" :leave-to-class="theme.fadeLeaveTo">
            <div v-if="isOpen" :class="menuClasses">
                <transition-group appear name="fade" :enter-active-class="theme.fadeEnterActive" :enter-class="theme.fadeEnter" :enter-to-class="theme.fadeEnterTo" :leave-active-class="theme.fadeLeaveActive" :leave-class="theme.fadeLeave" :leave-to-class="theme.fadeLeaveTo">
                    <div v-ripple v-for="item, index in items" :key="index" :class="theme.menuItem" @click="$emit('click', item)">
                        <v-text type="subheadling">{{ item }}</v-text>
                    </div>
                </transition-group>
            </div>
        </transition>
    </div>
</template>
<script>
    import { Ripple } from '../../directives';
    import theme from './menu.scss'

    export default {
        name: 'menu',
        props: {
            left: {
                type: Boolean,
                default: true,
            },
            right: {
                type: Boolean,
                default: false,
            },
            options: [Object, Array],
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        data() {
            return {
                isActive: false,
                isOpen: false,
            }
        },
        created() {
            window.addEventListener('click', this.handleClose);
        },
        destroyed() {
            window.removeEventListener('click', this.handleClose);
        },
        methods: {
            handleClose() {
                if (!this.isActive) {
                    this.isOpen = false;
                }
            },
            handleOpen() {
                this.isOpen = !this.isOpen;
            },
            handleFocus() {
                this.isActive = true;
            },
            handleBlur() {
                // isOpen: false, // autohide
                this.isActive = false;
            }
        },
        computed: {
            items() {
                return this.options;
            },
            menuClasses() {
                return {
                    [this.theme.menu]: true,
                    [this.theme.isRight]: this.right,
                    [this.theme.isLeft]: this.left && !this.right,
                }
            }
        },
        directives: {
            Ripple,
        },
    }
</script>


// WEBPACK FOOTER //
// Menu.vue?2fa2ca3d